import { Box } from "@mui/material";
import { TitleDatailInlineProps } from "../TitleDatailInline/TitleDatailInline";
import { DetailBoxWrapper } from "../DetailBoxWrapper/DetailBoxWrapper";

export type TitleDetailViewProps = {
  align?: "right" | "left";
  detailsColor?: () => string | undefined;
} & TitleDatailInlineProps;

export function TitleDetailView({
  title,
  detail,
  align = "left",
  detailsColor = () => {
    return undefined;
  },
}: TitleDetailViewProps): JSX.Element {
  return (
    <Box style={{ overflow: "hidden", width: "100%" }}>
      <DetailBoxWrapper
        sx={{
          fontSize: "0.875rem",
          textAlign: align,

          color: "text.secondary",
        }}
      >
        {title}
      </DetailBoxWrapper>
      <DetailBoxWrapper
        sx={{
          fontSize: "1.125rem",
          color: detailsColor(),
          textAlign: align,
        }}
      >
        {detail}
      </DetailBoxWrapper>
    </Box>
  );
}
export default TitleDetailView;
